import styled from 'styled-components';
import { Button, Row } from '@snsw-gel/react';

export const StyledBackButton = styled(Button)`
  width: fit-content;
`;

export const StyledRow = styled(Row)`
  margin-top: 2.5rem;
`;

export const FormContainer = styled.div`
  max-width: 628px;
  div:has(textarea) {
    max-width: unset;
  }
`;
